<template>
  <nav class="fixed top-0 left-0 w-full text-brand-cream z-50 border-b border-brand-surface/80 backdrop-blur-sm" style="background: var(--nav-bg);">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-16">
      <!-- Logo -->
      <router-link to="/" class="group flex items-baseline gap-1.5">
        <span class="text-2xl font-bold tracking-tight">b_isry</span>
        <span class="sketch-label text-brand-muted/70 group-hover:text-brand-muted transition" aria-hidden="true">✦</span>
      </router-link>

      <!-- Desktop Links + theme toggle -->
      <div class="hidden md:flex space-x-8 items-center">
        <router-link
          to="/"
          class="hover:text-brand-muted transition duration-300 pb-1"
          :class="{ 'border-b border-brand-cream/80': $route.path === '/' }"
        >
          About
        </router-link>
        <router-link
          to="/projects"
          class="hover:text-brand-muted transition duration-300 pb-1"
          :class="{ 'border-b border-brand-cream/80': $route.path === '/projects' }"
        >
          Projects
        </router-link>
        <router-link
          to="/educexp"
          class="hover:text-brand-muted transition duration-300 pb-1"
          :class="{ 'border-b border-brand-cream/80': $route.path === '/educexp' }"
        >
          Experience
        </router-link>
        <router-link
          to="/contact"
          class="hover:text-brand-muted transition duration-300 pb-1"
          :class="{ 'border-b border-brand-cream/80': $route.path === '/contact' }"
        >
          Contact
        </router-link>

        <button
          type="button"
          class="theme-toggle ml-1"
          :aria-label="isDark ? 'Switch to light mode' : 'Switch to dark mode'"
          :title="isDark ? 'Switch to light mode' : 'Switch to dark mode'"
          @click="toggleTheme"
        >
          <span class="theme-toggle__icon" aria-hidden="true">{{ isDark ? '☀' : '☾' }}</span>
        </button>
      </div>

      <!-- Mobile: theme + hamburger -->
      <div class="md:hidden flex items-center gap-2">
        <button
          type="button"
          class="theme-toggle"
          :aria-label="isDark ? 'Switch to light mode' : 'Switch to dark mode'"
          :title="isDark ? 'Switch to light mode' : 'Switch to dark mode'"
          @click="toggleTheme"
        >
          <span class="theme-toggle__icon" aria-hidden="true">{{ isDark ? '☀' : '☾' }}</span>
        </button>
        <button @click="toggleMenu" class="focus:outline-none p-1" aria-label="Toggle menu">
          <svg
            class="w-6 h-6 text-brand-cream"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 6h16M4 12h16m-7 6h7"
            />
          </svg>
        </button>
      </div>
    </div>

    <!-- Mobile Menu -->
    <div
      v-show="menuOpen"
      class="md:hidden bg-brand-dark text-brand-cream space-y-4 px-4 py-6 border-t border-brand-surface"
    >
      <router-link to="/" class="block hover:text-brand-muted pb-1" :class="{ 'border-b border-brand-cream/80': $route.path === '/' }" @click="menuOpen = false">About</router-link>
      <router-link to="/projects" class="block hover:text-brand-muted pb-1" :class="{ 'border-b border-brand-cream/80': $route.path === '/projects' }" @click="menuOpen = false">Projects</router-link>
      <router-link to="/educexp" class="block hover:text-brand-muted pb-1" :class="{ 'border-b border-brand-cream/80': $route.path === '/educexp' }" @click="menuOpen = false">Experience</router-link>
      <router-link to="/contact" class="block hover:text-brand-muted pb-1" :class="{ 'border-b border-brand-cream/80': $route.path === '/contact' }" @click="menuOpen = false">Contact</router-link>
    </div>
  </nav>
</template>

<script>
import { ref } from "vue";
import { useTheme } from "../composables/useTheme";

export default {
  setup() {
    const menuOpen = ref(false);
    const { isDark, toggleTheme } = useTheme();

    const toggleMenu = () => {
      menuOpen.value = !menuOpen.value;
    };

    return { menuOpen, toggleMenu, isDark, toggleTheme };
  },
};
</script>
